import { ValidatorFn } from "../lib/react-apollo-hooks-form";

export const notEmpty: ValidatorFn = (value) => {
  if (typeof value === "string" && value.length < 1) {
    return "Should not be left empty";
  }
};
